import { render, staticRenderFns } from "./app-account.vue?vue&type=template&id=3248fa67&"
import script from "./app-account.vue?vue&type=script&lang=js&"
export * from "./app-account.vue?vue&type=script&lang=js&"
import style0 from "./app-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports